import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast } from '../../models/toast.model';
import { KeeniconComponent } from '../keenicon/keenicon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-toast',
	standalone: true,
	imports: [CommonModule, KeeniconComponent, TranslateModule],
	templateUrl: './toast.html',
})
export class ToastComponent implements OnInit, OnDestroy {
	@Input({ required: true }) toast!: Toast;
	@Output() close = new EventEmitter<string>();
	@Output() remove = new EventEmitter<string>();

	private autoCloseTimeout?: number;

	ngOnInit() {
		this.setupAutoClose();
	}

	ngOnDestroy() {
		this.clearAutoCloseTimeout();
	}

	private setupAutoClose(): void {
		if (this.toast.autoClose !== false && this.toast.duration) {
			this.autoCloseTimeout = window.setTimeout(() => {
				this.onClose();
			}, this.toast.duration);
		}
	}

	private clearAutoCloseTimeout(): void {
		if (this.autoCloseTimeout) {
			clearTimeout(this.autoCloseTimeout);
			this.autoCloseTimeout = undefined;
		}
	}

	onClose(): void {
		this.clearAutoCloseTimeout();
		this.close.emit(this.toast.id);
	}
}
